import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../../types/iso-date';
import { constructDate } from '../../helper/construct-date.function';
import { deconstructDate } from '../../helper/deconstruct-date.function';

/**
 * Returns the end of the day for the given ISO input.
 * - Date-only (YYYY-MM-DD) -> returns 'YYYY-MM-DD'
 * - Date-time without tz -> returns 'YYYY-MM-DDT23:59:59.999'
 * - Date-time with tz -> returns 'YYYY-MM-DDT23:59:59.999Z|±HH:MM'
 */
export function endOfDay<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (
    deconstructed._type !== 'date' &&
    deconstructed._type !== 'dateTime' &&
    deconstructed._type !== 'dateTimeTz'
  ) {
    throw new Error('endOfDay: invalid ISO date/time string');
  }
  if (deconstructed._type !== 'date') {
    deconstructed.hours = 23;
    deconstructed.minutes = 59;
    deconstructed.seconds = 59;
    deconstructed.milliseconds = 999;
  }
  return constructDate(deconstructed) as unknown as T;
}
